"use strict";

var _AsyncBoundary;
import { FleetCompanyProvider } from '@autoguru/components/FleetCompanyProvider';
import { OverdriveProvider } from '@autoguru/overdrive';
import { EnvironmentProvider, createEnvironment } from '@autoguru/relay';
import { AsyncBoundary } from '@autoguru/suspense';
import { invariant } from '@autoguru/utilities';
import { HomeComponent } from '../scenes/Homepage';
import { jsx as _jsx } from "react/jsx-runtime";
const relayModernEnvironment = createEnvironment();
const getFleetCompany__unstable = () => {
  if (process.env.NODE_ENV !== "production") return {
    slug: 'ampol',
    id: '1'
  };
  if ('fleetCompanySlug' in window && 'fleetCompanyId' in window) {
    return {
      slug: window['fleetCompanySlug'],
      id: window['fleetCompanyId']
    };
  }
  return null;
};
export const App = () => {
  const fleetCompany = getFleetCompany__unstable();
  !(fleetCompany !== null) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Fleet company id and slug is not provided') : invariant(false) : void 0;
  return /*#__PURE__*/_jsx(OverdriveProvider, {
    children: /*#__PURE__*/_jsx(EnvironmentProvider, {
      environment: relayModernEnvironment,
      children: /*#__PURE__*/_jsx(FleetCompanyProvider, {
        slug: fleetCompany.slug,
        id: fleetCompany.id,
        children: _AsyncBoundary || (_AsyncBoundary = /*#__PURE__*/_jsx(AsyncBoundary, {
          fallback: null,
          children: /*#__PURE__*/_jsx(HomeComponent, {})
        }))
      })
    })
  });
};